import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'sc-slide-toggle-field',
  templateUrl: './slide-toggle-field.component.html',
  styleUrls: ['./slide-toggle-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SlideToggleFieldComponent),
      multi: true
    }
  ]
})
export class SlideToggleFieldComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() placeholder: string;
  @Input() options: any;

  public checked = false;

  private _value: any;

  constructor() {}

  onChange = (value: any) => {};
  onTouched = () => {};

  public ngOnInit() {}

  public check(value: boolean) {
    if (!this.disabled) {
      this.writeValue(value);
    }
  }

  public writeValue(checked: string | boolean) {
    this.checked = typeof checked === 'boolean' ? checked : this.options.truthy === checked;
    const value = !!this.checked ? this.options.truthy : this.options.falsy;
    setTimeout(() => {
      this.onChange(value);
    }, 20); // workaround
  }

  public registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
